import { render, staticRenderFns } from "./inactive_customer_report.vue?vue&type=template&id=417f9b75&"
import script from "./inactive_customer_report.vue?vue&type=script&lang=js&"
export * from "./inactive_customer_report.vue?vue&type=script&lang=js&"
import style0 from "./inactive_customer_report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports